import { loyaltyConfigurationSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod/v4";

export const getLoyaltyConfiguration = {
  name: "getLoyaltyConfiguration" as const,
  input: z.object({}),
  output: loyaltyConfigurationSchema.nullable(),
};
